module.exports = __webpack_public_path__ + "img/DE02189.adbc3cbc.png";